import { initHome } from './Home'
import { initAnnouncementTask } from './UserTasks/Announcement'
import { initUserCourseTask } from './UserTasks/Course'
import { initEnrollTask } from './UserTasks/Enroll'
import { initQuestionnaireTask } from './UserTasks/Questionnaire'
import { initQuizTask } from './UserTasks/Quiz'
import { initActivities } from './activities'
import { initAdmissions } from './admissions'
import { initGateway } from './gateway'
import { initGatewayManagement } from './gatewayManagement'
import { initHotNews } from './hot-news'
import { initStudentManagement } from './studentManagement'
import { initStudents } from './students'
import { initSystemSetting } from './systemSetting'
import { initTeacherManagement } from './teacherManagement'
import { initTestPaper } from './test-paper'
import { InitFeatureParams } from './types'

// 教师管理界面和用户前台界面分开注册，避免不必要的路由数据加载，
// 如果有界面是管理界面和前台界面都用到的，可以两个都注册一下

/**
 * 初始化教师管理界面，所有教师管理端界面的路由都在这里注册
 *
 * @param params - 初始化参数
 * @param params.hasAnyAdminPermission - 是否有管理权限
 */
export const initAdminFeatures = ({
  hasAnyAdminPermission = true,
  ...params
}: InitFeatureParams) => {
  // todo 权限机制，获取具体的权限，来筛除不需要加载的路由
  if (hasAnyAdminPermission) {
    initStudents(params),
      initAdmissions(params),
      initActivities(params),
      initTestPaper(params),
      initStudentManagement(params),
      initTeacherManagement(params),
      initGatewayManagement(params),
      initSystemSetting(params)
    initHotNews(params)
  }
  // 没有权限的话，只能初始化门户管理界面
  initGateway(params)
}

/**
 * 初始化用户前台界面，所有用户前台界面的路由都在这里注册
 *
 * @param params - 初始化参数
 */
export const initUserFeatures = (params: InitFeatureParams) => {
  initHome(params),
    initUserCourseTask(params),
    initQuestionnaireTask(params),
    initAnnouncementTask(params),
    initQuizTask(params),
    initEnrollTask(params)
}
